<ds-accordion>
    <ds-accordion-item
        class="sera-help-accordion"
        [labelTemplate]="headerLabel"
        [disabled]="loading ?? false"
        [isOpen]="isOpen"
        (toggleEvent)="isOpenChange(!isOpen)">
        <div
            class="sera-help-accordion__content"
            content>
            <span>{{ content.title | translate }}</span>
            <ul>
                <li *ngFor="let item of content.labels">{{ item.label | translate }}</li>
            </ul>
        </div>
    </ds-accordion-item>
</ds-accordion>
<ng-template #headerLabel>
    <span>{{ header }}</span>
</ng-template>
